import "./App.css";
import Weather from "./Weather.js";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="Japan" />

        <footer>
          By Annie Do
          <a href="https://thirsty-shockley-679896.netlify.app">
            {" "}
            hosted on Netflify{" "}
          </a>{" "}
          and is open-sourced on{" "}
          <a href="https://github.com/annie-2686/react-weather-app">GitHub</a>
        </footer>
      </div>
    </div>
  );
}
export default App;
